import React, { useState } from 'react';

import { apiBaseUrl } from '../../util/api';

import css from './NewsletterSignup.module.css';

// Nextmine: nyhedsbrev-tilmelding (opsamler emails via /api/newsletter).
// Genbruges flere steder på siden.
const NewsletterSignup = props => {
  const { className } = props;
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | done | error
  const [error, setError] = useState(null);

  const onSubmit = async e => {
    e.preventDefault();
    setError(null);
    setStatus('submitting');
    try {
      const resp = await fetch(`${apiBaseUrl()}/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await resp.json();
      if (!resp.ok) {
        throw new Error(data.error || 'Could not subscribe.');
      }
      setStatus('done');
    } catch (err) {
      setError(err.message);
      setStatus('error');
    }
  };

  if (status === 'done') {
    return (
      <p className={css.thanks}>Thank you - you're on the list. We'll be in touch with new treasures.</p>
    );
  }

  return (
    <form className={`${css.form} ${className || ''}`} onSubmit={onSubmit}>
      <input
        type="email"
        className={css.input}
        placeholder="Your email address"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        aria-label="Email address"
      />
      <button type="submit" className={css.button} disabled={status === 'submitting'}>
        {status === 'submitting' ? 'Joining…' : 'Sign up'}
      </button>
      {error ? <span className={css.error}>{error}</span> : null}
    </form>
  );
};

export default NewsletterSignup;
